export const accordionStylesSx = {
  border: '1px solid',
  backgroundColor: 'initial',
  borderColor: ({ palette }) => `${palette.border.default} !important`,
  borderRadius: '8px',
  boxShadow: 'none',

  '&:not(:last-child)': {
    marginBottom: '10px !important',
  },

  '&.MuiAccordion-root': {
    p: 1.5,
  },

  '&.MuiAccordion-root.Mui-expanded': {
    m: 0,
  },

  '& .MuiAccordionSummary-root': {
    p: 0,
    minHeight: '36px',
  },

  '& .MuiAccordionSummary-content': {
    alignSelf: 'flex-start',
    m: 0,

    '&.Mui-expanded': {
      m: 0,
    },
  },

  '& .MuiAccordionSummary-expandIconWrapper': {
    alignSelf: 'flex-start',
  },

  '& .MuiAccordionDetails-root': { m: 0, p: 0 },

  h3: {
    fontSize: 20,
    lineHeight: 28,
    fontWeight: 500,
    color: ({ palette }) => palette.text.primary,
  },

  '&:before': {
    height: 0,
  },
};

export const tableContainerStylesSx = {
  border: '1px solid',
  borderColor: ({ palette }) => palette.border.default,
  borderRadius: '8px',
  marginTop: '10px',
};

export const tableHeadStylesSx = {
  backgroundColor: ({ palette }) => palette.background.secondary,
  borderColor: ({ palette }) => palette.border.default,
  borderBottom: 'none',
  height: '46px',

  '& th': {
    '&:nth-of-type(1)': { width: '40%' },
    '&:nth-of-type(2)': { width: '60%' },
    border: 'none',
    padding: '10px 16px',
  },
};

export const tableBodyStylesSx = {
  '& tr:not(:last-child)': {
    borderBottom: '1px solid',
    borderColor: ({ palette }) => palette.border.default,
  },

  '& td': {
    color: ({ palette }) => palette.text.dark,
    border: 'none',
  },
};
